import { UserMessage } from '../models/interfaces/user-message.interface';

export const createUserMessage = (
  idAuthor: string,
  idDest: string,
  textMessage: string,
  file?: File
): UserMessage => {
  return {
    idAuthor: idAuthor,
    idDest: idDest,
    text: textMessage,
    dtMessage: new Date(),
    active: true,
    sent: true,
    received: false,
    visualized: false,
    attachment: file ? { file } : undefined,
  };
};
